import jsxElementToImgBase64 from "Common/componentUtils/jsxElementToImgBase64";
import urlToBase64 from "Common/componentUtils/urlToBase64";
import startsWith from "lodash/startsWith";
import React from "react";
export default async (imgSrc, size, className, abortController) => {
    if (!imgSrc)
        return null;
    let src = imgSrc;
    if (!startsWith(src, window.location.origin) && !startsWith(src, "/")) {
        await new Promise(resolve => {
            urlToBase64(src, (res) => {
                if (res)
                    src = res;
                resolve(res);
            });
        });
    }
    const label = (React.createElement("div", { style: { lineHeight: `${size}px`, width: size, height: size }, className: className },
        React.createElement("img", { src: src, width: "100%", height: "100%", className: "img-cover" })));
    return jsxElementToImgBase64(label, undefined, abortController);
};
